/* Dudes Boutique — open the product lightbox from the image itself.

   Dawn covers the photo with an invisible full-size button, which is the
   click target for zoom. That also means a right-click lands on the button,
   so the browser never offers "Copy image". The stylesheet drops that cover
   (pointer-events: none on its ::after); this restores click-to-zoom by
   forwarding a click on the image to the button Dawn already wired up.

   Delegated, so it survives the gallery re-rendering on variant change. */
(function () {
  var MOVE_TOLERANCE = 10; // px — a swipe on mobile must not open the lightbox
  var startX = 0;
  var startY = 0;
  var moved = false;

  document.addEventListener(
    'pointerdown',
    function (event) {
      startX = event.clientX;
      startY = event.clientY;
      moved = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (moved) return;
      if (
        Math.abs(event.clientX - startX) > MOVE_TOLERANCE ||
        Math.abs(event.clientY - startY) > MOVE_TOLERANCE
      ) {
        moved = true;
      }
    },
    { passive: true }
  );

  document.addEventListener('click', function (event) {
    if (moved) return;
    if (event.button && event.button !== 0) return;

    var image = event.target.closest('.product__modal-opener--image .product__media img');
    if (!image) return;

    // not the thumbnail rail, and not the images already inside the lightbox
    if (image.closest('.thumbnail-list') || image.closest('.product-media-modal')) return;

    var opener = image.closest('modal-opener');
    if (!opener) return;

    var toggle = opener.querySelector('.product__media-toggle');
    if (!toggle) return;

    event.preventDefault();
    toggle.click();
  });
})();
